import React from 'react'
import { NavBar } from '../components/navBar'
// import { ProfileTwo } from '../components/profileTwo'
import {Profile} from '../components/profile'

export const ProfileScreen = () => {
  return (
    <>
      <NavBar />
      <Profile />
      {/* <ProfileTwo /> */}
    </>
  )
}
